const ContactRole = Object.freeze({
  MEDECIN: 'Médecin',
  ORATEUR: 'Orateur',
  NOTAIRE: 'Notaire',
  TRANSPORTEUR: 'Transporteur',
  THANATO: 'Thanato'
})

export default ContactRole
